export const StatusState = Object.freeze({
  Pending: 1,
  Rejected: 2,
  Accepted: 3,
  Expired: 4
})
